import React from 'react'
import pic from '../images/image-victor.jpg'
import '../css/Circle.css'

const Circle = () => {
    return (
        <div className="circle">
         
                <img src={pic} alt="pic-here"/>

        </div>
    )
}

export default Circle
